import React from "react";
import { Link } from "react-router-dom";
import Form from "../form/Form";

function Footer() {
  const footerContent = [
    {
      id: 0,
      name: "503 Mangal Mahesh Baug, S.V. Road, Opp Sumer Nagar, Kora Kendra, Borivali (West), 400092",
    },
    {
      id: 1,
      name: "Contact Us:    +91 91371 39544 ",
    },
    {
      id: 2,
      name: "Email ID:     info@srujna.org ",
    },
  ];
  const footerLinks = [
    { id: 0, name: "Home", path: "/" },
    { id: 1, name: "About Us", path: "/about" },
    { id: 2, name: "Impact", path: "/impact" },
    { id: 2, name: "Goal", path: "/goal" },
    { id: 3, name: "Donate for a Cause", path: "/donateCause" },
    { id: 4, name: "Contribute", path: "/contribute" },
  ];
  return (
    <div
      style={{
        backgroundColor: "rgb(48, 47, 47)",
        display: "flex",
        justifyContent: "center",
        padding: "15px 35px",
        color: "white",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "start",
          flex: 1,
          padding: "0px 15px",
        }}
      >
        <div style={{ fontSize: "24px" }}>Women Wings</div>
        {footerContent?.map((item, index) => {
          return (
            <div style={{ padding: "6px 0px" }} key={index}>
              {item?.name}
            </div>
          );
        })}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          textAlign: "start",
          flex: 1,
          padding: "0px 15px",
        }}
      >
        <div style={{ fontSize: "24px" }}>Quick links</div>
        {footerLinks?.map((item, index) => {
          return (
            <Link
              to={item?.path}
              key={index}
              style={{
                textDecoration: "none",
                color: "#fff",
                padding: "4px 0px",
              }}
            >
              {item?.name}
            </Link>
          );
        })}
      </div>
      <div style={{ flex: 1, padding: "0px 15px" }}>
        <Form
          style={{
            maxWidth: "340px",
            backgroundColor: "transparent",
            height: "100%",
            padding: 0,
          }}
          title="REQUEST A CALLBACK"
        />
      </div>
    </div>
  );
}

export default Footer;
